<template>
	<div class="main">
		<hwk-header type="/"></hwk-header>
		<div class="warp" style="margin: 20px auto;">
			<div class="warp1">
				<div class="block1">
					<img src="@/assets/index0.png" />
					<p class="p1">{{today_order.order_count}}<i>单</i></p>
					<p class="p2"><i>￥</i>{{today_order.order_sum_price||0}}</p>
				</div>
				<div class="block2">
					<img src="@/assets/index20.png" />
					<p><i>￥</i>{{user_money.all_money}}</p>
					<div class="nums">
						<div class="i">￥<span>{{user_money.money}}</span></div>
						<div class="line">|</div>
						<div class="i c2" v-if="user_money && user_money.consume_money">
							￥<span>{{user_money.consume_money.toFixed(2)}}</span></div>
					</div>
					<div class="progress"><span :style="{width:getwidth(user_money)}"></span></div>
				</div>
				<div class="block3">
					<div class="item pointer" v-for="(item,index) in notice" :key="index" @click="pageToNotice(item)">
						<div class="i-l"><span :class="{on:item.is_read==0}"></span>{{item.title}}</div>
						<div class="i-r">{{$timeFormat(item.createtime,'yyyy-mm-dd')}}</div>
					</div>
				</div>
			</div>
			<div class="warp2">
				<div class="w2-l">
					<div class="block">
						<div class="order-t">
							<div class="title">订单数据</div>
							<div class="time">{{$timeFormat(new Date(),'yyyy-mm-dd hh:MM:ss')}} 已更新</div>
						</div>
						<div class="order-list">
							<div class="item pointer" @click="pageToOrder(10)">
								<div class="l">
									<p>待支付</p>
									<h4>{{order_status[10]}}</h4>
								</div>
								<div class="r">
									<img src="@/assets/io1.png" />
								</div>
							</div>
							<div class="item pointer" @click="pageToOrder(15)">
								<div class="l">
									<p>支付待审核</p>
									<h4>{{order_status[15]}}</h4>
								</div>
								<div class="r">
									<img src="@/assets/io2.png" />
								</div>
							</div>
							<div class="item pointer" @click="pageToOrder(20)">
								<div class="l">
									<p>待发货</p>
									<h4>{{order_status[20]}}</h4>
								</div>
								<div class="r">
									<img src="@/assets/io3.png" />
								</div>
							</div>
							<div class="item pointer" @click="pageToOrder('')">
								<div class="l">
									<p>售后/退款</p>
									<h4>{{group_order_refund}}</h4>
								</div>
								<div class="r">
									<img src="@/assets/io4.png" />
								</div>
							</div>
						</div>
					</div>
					<div class="block">
						<div class="order-t">
							<div class="title">销售额</div>
							<div class="time">{{$timeFormat(new Date(),'yyyy-mm-dd hh:MM:ss')}} 已更新</div>
						</div>
						<div class="order-list2">
							<div class="item pointer" @click="pageToOrder2(0)">
								<div class="i-t">
									<img src="@/assets/io5.png" /><span>本月订单</span>
								</div>
								<div class="i-b">
									<div class="i">
										<p>单量</p>
										<h4>{{order_month.count_ids||0}}</h4>
									</div>
									<div class="i">
										<p>金额（￥）</p>
										<h4>{{order_month.sum_price||0}}</h4>
									</div>
								</div>
							</div>
							<div class="item pointer" @click="pageToOrder2(1)">
								<div class="i-t">
									<img src="@/assets/io6.png" /><span>本年订单</span>
								</div>
								<div class="i-b">
									<div class="i">
										<p>单量</p>
										<h4>{{order_year.count_ids||0}}</h4>
									</div>
									<div class="i">
										<p>金额（￥）</p>
										<h4>{{order_year.sum_price||0}}</h4>
									</div>
								</div>
							</div>
							<div class="item pointer" @click="pageToOrder2(2)">
								<div class="i-t">
									<img src="@/assets/io7.png" /><span>全部订单</span>
								</div>
								<div class="i-b">
									<div class="i">
										<p>单量</p>
										<h4>{{order_all.count_ids||0}}</h4>
									</div>
									<div class="i">
										<p>金额（￥）</p>
										<h4>{{order_all.sum_price||0}}</h4>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="w2-r">
					<div class="bd-nav">
						<div class="item pointer" :class="{on:bdIndex == 0}" @click="bdIndex = 0">国家榜单</div>
						<div class="item pointer" :class="{on:bdIndex == 1}" @click="bdIndex = 1">商品榜单</div>
					</div>
					<div class="bd-list" v-if="bdIndex == 0">
						<div class="item pointer" v-for="(item,index) in order_country_level" :key="index">
							<div class="i-l">
								<img src="@/assets/c1.png" v-if="index == 0" />
								<img src="@/assets/c2.png" v-else-if="index == 1" />
								<img src="@/assets/c3.png" v-else-if="index == 2" />
								<span class="n" v-else>{{index + 1}}</span>
								<span class="t">{{item.country}}</span>
							</div>
							<div class="i-r"><i class="i1">订单量</i><i class="i2"></i>{{item.count_ids}}</div>
						</div>

					</div>
					<div class="bd-list" v-if="bdIndex == 1">
						<div class="item pointer" v-for="(item,index) in order_goods_level" :key="index">
							<div class="i-l">
								<img src="@/assets/c1.png" v-if="index == 0" />
								<img src="@/assets/c2.png" v-else-if="index == 1" />
								<img src="@/assets/c3.png" v-else-if="index == 2" />
								<span class="n" v-else>{{index + 1}}</span>
								<span class="t">{{item.goods_title}}</span>
							</div>
							<div class="i-r"><i class="i1">订单量</i><i class="i2"></i>{{item.count_ids}}</div>
						</div>

					</div>
				</div>
			</div>
			<div class="warp3">
				<div class="title"><img src="@/assets/ip1.png" alt="" /><span>推荐产品</span><img src="@/assets/ip2.png"
						alt="" /></div>
				<div class="more" @click="pageTo('goodsList')">查看更多<i class="el-icon-arrow-right"></i></div>
				<div class="list">
					<div class="item" v-for="(item,index) in list" :key="index" @click="toDetails(item.id)">
						<div class="img">
							<img :src="http + item.image" />
						</div>
						<div class="con">
							<div class="name">{{item.title}}</div>
							<div class="price">{{getGoodsPrice(item)}}元</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<navigation :cartshow="true"></navigation>
		<div class="hek-notice" v-if="hasNotice">
			<div class="notice-bg"></div>
			<div class="notice">
				<div class="n-title">
					公告信息
				</div>
				<div class="close" @click="hasNotice = false"><i class="el-icon-close"></i></div>
				<div class="n-con">
					<div class="t">{{ggData.title}}</div>
					<div class="c" v-html="ggData.content"></div>
					<div class="btn" @click="pageToNotice(ggData)">立即查看</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'

	export default {
		components: {
			navigation,
			hwkHeader
		},
		data() {
			return {
				http: this.$imgUrl,
				list: [],
				pageSize: 0,
				page: 1,
				bdIndex: 0,
				hasNotice: false,
				id: 1,
				group_order_refund: 0,
				notice: [],
				order_all: {},
				order_country_level: [],
				order_goods_level: [],
				order_month: {},
				order_status: {},
				order_year: {},
				today_order: {},
				user_money: {},
				ggData: {}

			};
		},
		created() {
			if (localStorage.getItem('token')) {
				this.getHomeData();
				this.getCart()
				this.getlist()
			} else {
				this.$message({
					message: '请先登录',
					type: 'warning'
				});
				setTimeout(() => {
					this.$router.push({
						path: "/login"
					});
				}, 1000)

			}
		},
		computed: {
			getwidth() {
				return (data) => {
					console.log(data, data.consume_money / data.all_money, 454545454)
					if (data && data.consume_money) {
						return (data.consume_money / data.all_money * 100).toFixed(2) + '%'
					} else {
						return 0
					}

				}
			},
			getGoodsPrice() {
				return (data) => {
					return localStorage.getItem('userAttest') == 0 ? data.out_price : data.price
				}
			},

		},
		methods: {
			getlist() {
				this.$http.get('/api/goods/index', {
					params: {
						page: 1,
						limit: 5,
						is_home_recommend: 1,
						sort: 1
					}
				}).then(res => {
					this.list = res.data.data
				});
			},

			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			pageToOrder2(i) {
				let times = []

				function formatDate(date) {
					const y = date.getFullYear();
					const m = String(date.getMonth() + 1).padStart(2, '0');
					const d = String(date.getDate()).padStart(2, '0');
					return `${y}-${m}-${d}`;
				}

				if (i == 0) {
					function getFirstAndLastDayOfMonthFormatted() {
						const now = new Date(); // 当前日期
						const year = now.getFullYear();
						const month = now.getMonth();
						// 当月第一天
						const firstDay = new Date(year, month, 1);
						// 当月最后一天（下个月的前一天）
						const lastDay = new Date(year, month + 1, 0);
						return {
							firstDay: formatDate(firstDay),
							lastDay: formatDate(lastDay)
						};
					}
					// 使用
					const {
						firstDay,
						lastDay
					} = getFirstAndLastDayOfMonthFormatted();
					times = `${firstDay},${lastDay}`
				} else if (i == 1) {
					function getFirstAndLastDayOfYearFormatted() {
						const now2 = new Date();
						const year2 = now2.getFullYear();
						const firstDay2 = new Date(year2, 0, 1);
						const lastDay2 = new Date(year2, 11, 31);

						return {
							firstDay2: formatDate(firstDay2),
							lastDay2: formatDate(lastDay2)
						};
					}
					// 使用
					const {
						firstDay2,
						lastDay2
					} = getFirstAndLastDayOfYearFormatted();
					times = `${firstDay2},${lastDay2}`
				} else {
					times = ''
				}
				this.$router.push({
					path: "/orderList",
					query: {
						times: times
					}
				});
			},
			pageToNotice(data) {
				this.getNdata(data.id)
				localStorage.setItem('noticeInfo', JSON.stringify(data));
				localStorage.setItem('noticeId', data.id);
				this.$router.push({
					path: "/notice",

				});
			},

			pageToOrder(s) {
				this.$router.push({
					path: "/orderList",
					query: {
						status: s
					}
				});
			},
			toDetails(id) {
				this.$router.push({
					path: "/goodsDetails",
					query: {
						id: id
					}
				});
			},
			getHomeData() {

				this.$http.get('/api/home/index', {

				}).then(res => {
					this.group_order_refund = res.data.group_order_refund
					this.notice = res.data.notice
					this.order_all = res.data.order_all
					this.order_country_level = res.data.order_country_level.slice(0, 6);
					this.order_goods_level = res.data.order_goods_level.slice(0, 6);
					this.order_month = res.data.order_month
					this.order_status = res.data.order_status
					this.order_year = res.data.order_year
					this.today_order = res.data.today_order
					this.user_money = res.data.user_money
					if (this.notice.length) {
						let index = this.notice.findIndex(item => item.is_read == 0)
						if (index > -1) {
							this.ggData = this.notice[index]
							this.hasNotice = true
							if (localStorage.getItem('noticeId') && localStorage.getItem('noticeId') == this.ggData
								.id) {
								this.hasNotice = false
							}
							localStorage.setItem('noticeId', this.ggData.id)
							this.getNdata(this.ggData.id)
						}


					}
				});

			},
			getNdata(id) {
				this.$http.get('/api/home/notice_read', {
					params: {
						id: id
					}
				}).then(res => {

				});
			},
			getCart() {
				this.$http.get('/api/user_car/index', {

				}).then(res => {
					console.log(111111111)
					let number = res.data.data.length
					console.log(number, 'number')
					localStorage.setItem('cartNumber', number);
					this.$store.dispatch('setCartNumber', number);

				});
			},
		},
	};
</script>
<style lang="less" scoped>
	@color: #FF6A00;

	.notice-bg {
		content: '';
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.6);
		z-index: 9998;
	}

	.notice {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 400px;
		height: 332px;
		z-index: 9999;
		background: url('../assets/nbg.png') center no-repeat;

		.n-title {
			width: calc(100% - 40px);
			height: 60px;
			line-height: 60px;
			text-align: center;
			font-size: 20px;
			color: #fff;
			font-weight: 600;
			margin: 0 auto;
			border-top-left-radius: 20px;
			border-top-right-radius: 20px;
		}

		.close {
			position: absolute;
			top: 20px;
			right: 40px;
			color: #fff;
			font-size: 16px;
		}

		.n-con {
			width: 100%;
			border-radius: 20px;
			padding: 20px;
			box-sizing: border-box;

			.t {
				font-size: 16px;
				color: #333;
				line-height: 30px;
				height: 30px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}

			.c {
				margin-top: 10px;
				font-size: 14px;
				color: #666;
				line-height: 24px;
				text-align: left;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 4;
				overflow: hidden;
				min-height: 120px;
			}

			.btn {
				width: 120px;
				height: 40px;
				line-height: 40px;
				color: #fff;
				background-color: #FF6A00;
				margin: 20px auto;
				cursor: pointer;
				text-align: center;

				&:hover {
					background-color: #FFA75D;
				}
			}

		}
	}

	.main {



		.warp3 {
			background-color: #fff;
			border-radius: 10px;
			padding: 20px;
			margin-top: 20px;
			position: relative;

			.list {
				display: grid;
				grid-template-columns: repeat(5, 1fr);
				gap: 20px;
				margin-top: 20px;

				.item {
					border: 1px solid #eee;
					cursor: pointer;
					border-radius: 10px;
					overflow: hidden;

					&:hover {
						border: 1px solid @color;

						.con {
							.name {
								color: @color;
							}

							.price {
								color: @color;
							}

						}
					}

					.img {
						width: 100%;
						position: relative;
						padding-top: 100%;
						height: 0;

						img {
							position: absolute;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
							width: 100%;
							height: 100%;
						}
					}

					.con {
						padding: 10px;
						text-align: center;

						.name {
							font-size: 15px;
							color: #3F3F3F;
							line-height: 30px;
						}

						.price {
							font-size: 15px;
							color: #11192D;
							line-height: 30px;
							height: 30px;
						}

					}
				}
			}

			.title {
				text-align: center;
				height: 40px;
				line-height: 40px;
				font-size: 20px;
				color: #3F3F3F;
				font-weight: 600;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 12px;
					height: 9px;
				}

				span {
					padding: 0 10px;
				}

			}

			.more {
				position: absolute;
				top: 20px;
				right: 20px;
				font-size: 16px;
				color: #A9A9A9;
				cursor: pointer;

				i {
					margin-left: 5px;
				}

			}
		}

		.m20 {
			margin: 20px auto;
		}

		.warp2 {
			display: grid;
			grid-template-columns: 1fr 300px;
			grid-gap: 20px 20px;
			margin: 20px auto;

			.w2-l {
				.block {
					background-color: #fff;
					border-radius: 10px;
					padding: 20px;
					margin-bottom: 20px;

					&:nth-child(2) {
						margin-bottom: 0;
					}

					.order-list2 {
						display: grid;
						grid-template-columns: repeat(3, 1fr);
						gap: 10px;
						margin-top: 10px;

						.item {
							border: 1px solid #eee;
							padding: 10px 20px;
							border-radius: 10px;

							.i-t {
								height: 40px;
								line-height: 40px;
								display: flex;
								align-items: center;

								img {
									width: 20px;
									height: 20px;
								}

								span {
									font-size: 20px;
									color: #000;
									margin-left: 10px;
								}
							}

							.i-b {
								display: flex;
								align-items: center;
								margin-top: 10px;

								.i {
									text-align: left;

									p {
										font-size: 16px;
										color: #666;
										height: 20px;
										line-height: 20px;
									}

									h4 {
										font-size: 24px;
										color: #000;
										font-weight: 600;
										height: 40px;
										line-height: 40px;
										font-family: 'DIN';
									}

									&:nth-child(1) {
										padding-right: 30px;
										position: relative;

										&::after {
											position: absolute;
											top: 50%;
											right: 0;
											content: "";
											transform: translateY(-50%);
											color: #eee;
											width: 1px;
											height: 40px;
											background-color: #eee;
										}
									}

									&:nth-child(2) {
										padding-left: 30px;
									}
								}
							}
						}
					}

					.order-list {
						display: grid;
						grid-template-columns: repeat(4, 1fr);
						gap: 10px;
						margin-top: 10px;


						.item {

							display: flex;
							align-items: center;
							justify-content: space-between;
							padding: 20px;
							border-radius: 10px;

							&:nth-child(1) {
								background-color: #FFF1F1;
							}

							&:nth-child(2) {
								background-color: #F3F9FF;
							}

							&:nth-child(3) {
								background-color: #F3FEF2;
							}

							&:nth-child(4) {
								background-color: #FFF4ED;
							}

							.l {
								flex: 1;
								width: 1px;
								text-align: left;

								p {
									color: #666;
									font-size: 14px;
									height: 20px;
									line-height: 20px;
								}

								h4 {
									font-family: 'DIN';
									color: #333;
									font-size: 30px;
									font-weight: 600;
									height: 30px;
									line-height: 30px;
									margin-top: 10px;
								}
							}

							.r {
								width: 50px;
								height: 50px;

								img {
									width: 100%;
									height: 100%;
								}
							}
						}
					}

					.order-t {
						display: flex;
						align-items: center;
						height: 30px;
						line-height: 30px;

						.title {
							font-size: 20px;
							color: #000;
							font-weight: 600;
							text-indent: 15px;
							position: relative;

							&::after {
								position: absolute;
								top: 50%;
								left: 0;
								content: '';
								width: 4px;
								height: 18px;
								border-radius: 2px;
								background-color: #FF6A00;
								transform: translateY(-50%);
							}
						}

						.time {
							margin-left: 20px;
							font-size: 14px;
							color: #ADAAAA;
						}
					}
				}
			}

			.w2-r {
				background-color: #fff;
				border-radius: 10px;
				padding: 10px;

				.bd-nav {
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1px solid #eee;
					text-align: center;

					.item {
						flex: 1;
						width: 1px;
						height: 50px;
						line-height: 50px;
						font-size: 16px;
						color: #A9A9A9;
						cursor: pointer;
					}

					.on {
						position: relative;
						color: @color;
						font-weight: 600;

						&::after {
							content: '';
							position: absolute;
							bottom: 0;
							left: 0;
							right: 0;
							height: 2px;
							background-color: @color;
						}
					}
				}

				.bd-list {
					margin-top: 10px;

					.item {
						display: flex;
						align-items: center;
						justify-content: space-between;
						height: 50px;
						line-height: 50px;

						.i-l {
							display: flex;
							align-items: center;
							;
							justify-content: space-between;

							span {
								margin-right: 10px;
							}

							img {
								width: 27px;
								height: 30px;
								margin-right: 10px;
							}

							.n {
								width: 27px;
								height: 30px;
								font-family: 'DIN';
								font-weight: bold;
								font-size: 24px;
								color: #717171;
								text-align: center;
								line-height: 30px;
								display: inline-block;
							}

							.t {
								font-size: 16px;
								color: #000;
							}

						}

						.i-r {
							.i1 {
								font-size: 12px;
								color: #A9A9A9;
								margin-right: 5px;
								font-style: normal;

							}

							.i2 {
								font-size: 12px;
								color: #000000;
								font-family: 'DIN';
							}
						}
					}
				}
			}
		}

		.warp1 {

			// display: grid;
			// grid-template-columns: 1fr 1fr 360px;
			// grid-gap: 20px 20px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.block1 {
				position: relative;
				background: url('../assets/index1.png') center no-repeat;
				width: 490px;
				height: 160px;

				img {
					width: 118px;
					height: 28px;
					position: absolute;
					top: 17px;
					right: 28px;
				}

				p {
					color: #2C276C;
					font-size: 30px;
					font-weight: 600;
					position: absolute;
					font-family: 'DIN', 'Times New Roman', Times, serif;

					i {
						font-size: 12px;

						font-style: normal;
					}
				}

				.p1 {
					top: 64px;
					right: 34px;
				}

				.p2 {
					bottom: 20px;
					right: 34px;
				}
			}

			.block2 {
				position: relative;
				background-color: #FEF6F0;
				background: url('../assets/index2.png') center no-repeat;
				width: 350px;
				height: 160px;

				img {
					width: 118px;
					height: 28px;
					position: absolute;
					top: 20px;
					left: 20px;
				}

				.progress {
					position: absolute;
					bottom: 20px;
					left: 20px;
					right: 20px;
					height: 10px;
					background-color: #FFE4D2;
					border-radius: 53px;


					span {
						display: block;
						height: 10px;
						background-color: #FFA255;
						border-radius: 5px;
					}
				}

				.nums {
					position: absolute;
					bottom: 54px;
					right: 24px;
					display: flex;
					align-items: center;
					justify-self: flex-end;
					text-align: right;

					.line {
						padding: 0 20px;
						color: #FF821B;
					}

					.i {
						color: #FF821B;
						font-size: 12px;

						span {
							font-size: 20px;
							font-weight: 600;
							font-family: 'DIN', 'Times New Roman', Times, serif;
						}
					}

					.c2 {
						opacity: 0.5;

					}
				}

				p {
					color: #3F3F3F;
					font-size: 24px;
					font-weight: 600;
					position: absolute;
					top: 23px;
					right: 20px;
					font-family: 'DIN', 'Times New Roman', Times, serif;

					i {
						font-size: 12px;

						font-style: normal;
					}

				}
			}

			.block3 {
				background-color: #FFF7F3;
				background: url('../assets/index3.png') center no-repeat;
				width: 340px;
				height: 160px;
				overflow-y: auto;
				padding: 0 10px;
				box-sizing: border-box;

				.item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					line-height: 40px;
					height: 40px;
					position: relative;

					&::after {
						position: absolute;
						content: "";
						width: 6px;
						height: 6px;
						background: #D9D9D9;
						border-radius: 50%;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
						display: none;
					}

					&:nth-child(1) {
						&::after {
							background-color: #E62129;
						}
					}

					&:nth-child(2) {
						&::after {
							background-color: #E62129;
						}
					}


					.i-l {
						flex: 1;
						width: 1px;
						margin-right: 2px;
						padding-left: 10px;
						font-size: 14px;
						color: #8C8C8C;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						position: relative;

						span {
							position: absolute;
							top: 50%;
							margin-top: -3rpx;
							left: 0;
							width: 6px;
							height: 6px;
							display: inline-block;
							background: #D9D9D9;
							border-radius: 50%;
						}

						.on {
							background-color: #E62129;
						}

					}

					.i-r {
						width: 90px;
						color: #8C8C8C;
						font-size: 14px;
						text-align: right;
					}
				}
			}
		}


	}
</style>